module.exports = __webpack_public_path__ + "static/testimonial-thumb-2-34609a605bf24bc708ff99d33330c1ed.jpg";